export const GET_CLASSES_BEGIN = 'get_classes_begin';
export const GET_CLASSES_REQUESTING = 'get_classes_requesting';
export const GET_CLASSES_SUCCESS = 'get_classes_success';
export const GET_CLASSES_ERROR = 'get_classes_error';

export const GET_CLASS_BEGIN = 'get_class_begin';
export const GET_CLASS_REQUESTING = 'get_class_requesting';
export const GET_CLASS_SUCCESS = 'get_class_success';
export const GET_CLASS_ERROR = 'get_class_error';
export const GET_CLASS_RESET = 'get_class_reset';

export const SET_CLASS_BEGIN = 'set_class_begin';
export const SET_CLASS_REQUESTING = 'set_class_requesting';
export const SET_CLASS_SUCCESS = 'set_class_success';
export const SET_CLASS_ERROR = 'set_class_error';
export const SET_CLASS_RESET = 'set_class_reset';

export const UPDATE_CLASS_BEGIN = 'update_class_begin';
export const UPDATE_CLASS_REQUESTING = 'update_class_requesting';
export const UPDATE_CLASS_SUCCESS = 'update_class_success';
export const UPDATE_CLASS_ERROR = 'update_class_error';
export const UPDATE_CLASS_RESET = 'update_class_reset';

export const DELETE_CLASS_BEGIN = 'delete_class_begin';
export const DELETE_CLASS_REQUESTING = 'delete_class_requesting';
export const DELETE_CLASS_SUCCESS = 'delete_class_success';
export const DELETE_CLASS_ERROR = 'delete_class_error';
export const DELETE_CLASS_RESET = 'delete_class_reset';